module.exports = __webpack_public_path__ + "img/img-23.12076768.png";